import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        // Status pills: <role>-subtle background with its paired text color
        success: 'border-transparent bg-success-subtle text-success-subtle-foreground',
        warning: 'border-transparent bg-warning-subtle text-warning-subtle-foreground',
        info: 'border-transparent bg-info-subtle text-info-subtle-foreground',
        signal: 'border-transparent bg-signal-subtle text-signal-subtle-foreground',
        'destructive-subtle':
          'border-transparent bg-destructive-subtle text-destructive-subtle-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
